import {Component, Inject, OnInit} from '@angular/core';
import { InsuranceService } from '../insurance.service';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
    selector: 'app-insurance-select-fee-schedule',
    templateUrl: './insurance-select-fee-schedule.component.html',
    styleUrls: ['./insurance-select-fee-schedule.component.scss']
})
export class InsuranceSelectFeeScheduleComponent implements OnInit {

    constructor(
        private dialogRef: MatDialogRef<InsuranceSelectFeeScheduleComponent>,
        private insuranceService: InsuranceService,
        private dialog: MatDialog,
        private snackBar: MatSnackBar,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) { }

    listOfFeeSchedules: any[];

    selectedFeeSchedule: any ;
    FeeScheduleID: string ;
    FeeScheduleName: string;

    ngOnInit() {

        this.insuranceService.getFeeSchedules().subscribe(res => {

            this.listOfFeeSchedules = res;

            this.selectedFeeSchedule = this.listOfFeeSchedules[0];

        });


    }


    onFeeSelectionChanged(e:  any)  {

        this.FeeScheduleID = e.addedItems[0].FeeScheduleID;
        this.FeeScheduleName =   e.addedItems[0].FeeScheduleName;

    }

    onClose() {
        this.dialogRef.close({ FeeScheduleID: this.FeeScheduleID , FeeScheduleName: this.FeeScheduleName});

    }

    onCancel() {
      this.dialogRef.close(false);

    }






}
